import React from "react"
import {formatTextTestIds} from "@next/utils"
import {SaleImg} from "../../components"
import env from "../../../../config/env"
import {SaleSashPosition} from "../../../../config/constants"

export interface SaleSashProps {
    saleSashUrl: string | null
    saleSashPosition: SaleSashPosition | null
    sashAltText: string
    isOnSale: boolean
}

export const SaleSash = ({saleSashUrl, saleSashPosition, sashAltText, isOnSale}: SaleSashProps) => {
    if (!isOnSale || !saleSashUrl || !saleSashPosition) {
        return null
    }

    return (
        <SaleImg
            dir="ltr"
            className={SaleSashPosition[saleSashPosition]}
            src={`${env.REACT_APP_BLOB_STORAGE_PATH}/images/plp/sale/${saleSashUrl}`}
            data-testid={formatTextTestIds("product_summary_sale_sash")}
            alt={sashAltText}
        />
    )
}

export default SaleSash
